import { ArrowLeft, Heart, Bell } from 'lucide-react';
import type { TenantHeaderProps } from './types';

export function TenantHeader({
    tenantName,
    slug,
    isFavorite,
    isInstallable,
    onToggleFavorite,
    onInstallClick,
    onBackClick,
}: TenantHeaderProps) {
    if (!tenantName) return null;

    return (
        <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white py-4 px-4 shadow-md relative">
            {/* Back button */}
            <button
                onClick={onBackClick}
                className="absolute left-2 top-1/2 -translate-y-1/2 p-2 hover:bg-white/20 rounded-lg transition-colors"
                title="Retour à l'accueil"
            >
                <ArrowLeft className="w-5 h-5" />
            </button>

            {/* Title */}
            <h1 className="text-2xl font-bold text-center">{tenantName}</h1>

            {/* Right side buttons */}
            <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-2">
                {/* Favorite button */}
                {slug && (
                    <button
                        onClick={onToggleFavorite}
                        className="p-2 hover:bg-white/20 rounded-lg transition-colors"
                        title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
                    >
                        <Heart
                            className={`w-5 h-5 ${isFavorite ? 'fill-white' : ''}`}
                        />
                    </button>
                )}

                {/* PWA Install Button */}
                {isInstallable && (
                    <button
                        onClick={onInstallClick}
                        className="bg-white/20 hover:bg-white/30 text-white px-3 py-1.5 rounded-lg text-sm font-medium transition-colors flex items-center gap-2"
                        title="Installer l'application"
                    >
                        <Bell className="w-4 h-4" />
                        Installer
                    </button>
                )}
            </div>
        </div>
    );
}
